import { PropsWithChildren } from 'react';

export type TextGroupItem = {
  content: string;
  cssClass: string;
};

export type TextGroup = TextGroupItem[];

export enum TextGroupItemCSSClass {
  SHIFT_TITLE = 'title',
  SHIFT_TITLE_APPEND = 'shift-title-append',
}

export enum OrderBy {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export type ApiConfig = {
  page?: number | null;
  size?: number | null;
};


export interface CommonDialogProps extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
}
